import { render, staticRenderFns } from "./AdminMail.vue?vue&type=template&id=c54dbd4a&"
import script from "./AdminMail.vue?vue&type=script&lang=js&"
export * from "./AdminMail.vue?vue&type=script&lang=js&"
import style0 from "./AdminMail.vue?vue&type=style&index=0&id=c54dbd4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports